var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.list)?_c('div',{staticClass:"themeItem_mode_6"},[_c('EVENTCOP_MODE_6',{attrs:{"themeClass":'onlyDisplay',"currThemeObj":_vm.currThemeObj,"currCid":_vm.currCid,"currSid":_vm.currSid,"sportsTypeArr":_vm.sportsTypeArr,"currSportsDetail":_vm.currSportsDetail,"datas":_vm.list,"modeType":'double'}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }